import config from 'Config';
import Service from 'Services/Service';

export default class ExperimentsService extends Service {
  getExperiments = async (uuid: any): Promise<any> => {
    const options = this.apiClient.getDefaultOptions({
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ experiments: config.experiments, device_id: uuid }),
    });

    const response = await this.fetch(this.getEndpoint('preAuthBuckets'), options);
    const json = await response.json();
    return json;
  };
}
